import { render, staticRenderFns } from "./LongReminder_Index.vue?vue&type=template&id=51901776&scoped=true"
import script from "./LongReminder_Index.vue?vue&type=script&lang=js"
export * from "./LongReminder_Index.vue?vue&type=script&lang=js"
import style0 from "./LongReminder_Index.vue?vue&type=style&index=0&id=51901776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51901776",
  null
  
)

export default component.exports